import {EntityDocumentTypeEnum, UploadedFileModel} from "../../../models";
import React from "react";
import {UploadDialog} from "./uploadDialog";

interface UploadDialogWithHandlerWrapperProps  {
    uploadedFiles: UploadedFileModel[];
    handleSetUploadedFiles: (files: UploadedFileModel[]) => void; // Your custom handler
    entityDocumentType: keyof typeof EntityDocumentTypeEnum;
    requestId: number;
};

export const UploadDialogWithHandlerWrapper : React.FC<UploadDialogWithHandlerWrapperProps> = ({
                                                                                     uploadedFiles,
                                                                                     handleSetUploadedFiles,
                                                                                     entityDocumentType,
                                                                                     requestId,
                                                                                 }) => {
    // Wrap your handler into the expected signature
    const wrappedSetUploadedFiles = React.useCallback(
        (value: React.SetStateAction<UploadedFileModel[]>) => {
            if (typeof value === 'function') {
                const newState = value(uploadedFiles ?? []);
                handleSetUploadedFiles(newState);
            } else {
                handleSetUploadedFiles(value);
            }
        },
        [uploadedFiles, handleSetUploadedFiles]
    );

    return (
        <UploadDialog
            uploadedFiles={uploadedFiles}
            setUploadedFiles={wrappedSetUploadedFiles}
            entityDocumentType={entityDocumentType}
            requestId={requestId}
        />
    );
};
